import React from 'react'
import PropTypes from 'prop-types'
import styled, { cx } from 'react-emotion'
import { themeGet as th } from 'styled-system'
import themeVars from 'ui_theme/site/globals/site.variables'

import { ButtonWithDropdown } from 'shared/ui'
import ListenToKeyboard from 'components/ListenToKeyboard'
import DropdownSwitcher from './DropdownSwitcher'

const ButtonDisableWrapper = ({ className, disabled, children, passRef }) => {
  return (
    <div className={cx(className, disabled ? 'disabled' : null)} ref={passRef}>
      {children}
    </div>
  )
}

const ButtonDisableWrapperStyled = styled(ButtonDisableWrapper)`
  transition: opacity 200ms ease-in-out;

  &.disabled {
    opacity: 0.5;
    pointer-events: none;
  }
`

class Button extends React.PureComponent {
  state = { dropdownOpen: false }

  closeDropdown = () => this.setState({ dropdownOpen: false })

  openDropdown = () => {
    const { disabled } = this.props
    if (!disabled) this.setState({ dropdownOpen: true })
  }

  toggleDropdown = () =>
    this.state.dropdownOpen ? this.closeDropdown() : this.openDropdown()

  handleDropdownClick = e => {
    const clickedOption = e.target.closest('.item[role="option"]')
    const isSnoozeOption =
      clickedOption && /snooze/.test(clickedOption.textContent)

    if (clickedOption && !isSnoozeOption) {
      this.closeDropdown()
      return
    }
  }

  handleSnoozeOptionClick = (snoozeUntil, evt) => {
    const { onSnoozeOptionClick } = this.props
    if (onSnoozeOptionClick) onSnoozeOptionClick(snoozeUntil, evt)
    this.closeDropdown()
  }

  handleButtonClick = () => {
    const { disabled, onSend } = this.props
    if (disabled) return
    onSend()
    this.closeDropdown()
  }

  containerRef = node => (this.container = node)

  findTrigger = () =>
    this.container && this.container.querySelector('.dropdown.button')

  render() {
    const {
      className,
      disabled,
      isOpen,
      onSendOpenClick,
      onSendClosedClick,
    } = this.props
    const { dropdownOpen } = this.state

    return (
      <ButtonDisableWrapperStyled
        disabled={disabled}
        passRef={this.containerRef}
      >
        <ListenToKeyboard
          onEscape={this.closeDropdown}
          enabled={dropdownOpen}
        />
        <ButtonWithDropdown
          className={className}
          color={themeVars.golden}
          dropdown={
            <DropdownSwitcher
              isOpen={isOpen}
              onSendOpenClick={onSendOpenClick}
              onSendClosedClick={onSendClosedClick}
              onSnoozeOptionClick={this.handleSnoozeOptionClick}
              onFocus={this.openDropdown}
              onBlur={this.closeDropdown}
              openOnFocus={false}
            />
          }
          onClick={this.handleButtonClick}
        >
          Add note
        </ButtonWithDropdown>
      </ButtonDisableWrapperStyled>
    )
  }
}

Button.propTypes = {
  /* Whether the dropdown menu is disabled */
  disabled: PropTypes.bool,

  isOpen: PropTypes.bool.isRequired,

  /* onClick handlers for the button + each of the 3 DD menu options */
  onSend: PropTypes.func.isRequired,
  onSendOpenClick: PropTypes.func.isRequired,
  onSendClosedClick: PropTypes.func.isRequired,

  /* onClick handler for snooze menu options */
  onSnoozeOptionClick: PropTypes.func.isRequired,
}

Button.defaultProps = {
  disabled: false,
}

export default styled(Button)`
  &&& {
    .button {
      background-color: ${th('colors.golden')};
      color: ${th('colors.white')};

      &.upward.dropdown {
        &:hover,
        &.active {
          background-color: ${th('colors.lightGolden')};
          color: ${th('colors.white')};
        }
      }
    }
  }
`
